<template>
  <card>
    <h4>
      Отчет формируется только после того, как заказу установят статус "Товар у
      клиента"
    </h4>
    <list
      v-if="$store.state.user.sections['reports']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :staticFilters="staticFilters"
      :cardLink="cardLink"
      :isUpdate="true"
      :filters="filters"
      :isAdd="false"
      :setImport="true"
      :exportFields="exportFields"
      :itemLink="itemLink"
      :dateFilter="dateFilter"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        "Номер заказа": "order.id",
        "Номер заказа (партнер)": "exchange_id",
        "Статус (партнер)": "status",
        Партнер: "partner.name",
        Продавец: "user.phone",
        "Срок рассрочки": "month",
        Магазин: "shop.name",
        "Цена заказа": "order.price_total",
        "Дата создания заказа": {
          field: "order.created_at",
          callback: (val) => {
            try {
              if (val && typeof val == "string") {
                let date = new Date(val);
                return date.toLocaleString();
              }
              return "Нет даты";
            } catch (error) {
              return val;
            }
          },
        },
        "Дата создания продажи": {
          field: "created_at",
          callback: (val) => {
            try {
              if (val && typeof val == "string") {
                let date = new Date(val);
                return date.toLocaleString();
              }
              return "Нет даты";
            } catch (error) {
              return val;
            }
          },
        },
        "Номер клиента": {
          field: "client.phone",
          callback: (value) => {
            return "UZ " + value;
          },
        },
        Товары: {
          field: "purchases",
          callback: (value) => {
            let purchase = "";
            for (let i = 0; i < value.length; i++) {
              purchase += value[i].title;
            }
            return purchase;
          },
        },
        Акция: {
          field: "discounts",
          callback: (value) => {
            let val = "";
            for (let i = 0; i < value.length; i++) {
              val += value[i].promotion_name + " ";
            }
            return val;
          },
        },
        Скидки: {
          field: "discounts",
          callback: (value) => {
            let val = "";
            for (let i = 0; i < value.length; i++) {
              val += value[i].discount_total + " ";
            }
            return val;
          },
        },
      },
      staticFilters: [
        {
          title: "Фильтр по сроку",
          key: "month",
          default: "0",
          items: [
            {
              id: "0",
              title: "Показать все",
            },
            {
              id: "3",
              title: "3 месяца",
            },
            {
              id: "6",
              title: "6 месяцев",
            },
            {
              id: "9",
              title: "9 месяцев",
            },
            {
              id: "12",
              title: "12 месяцев",
            },
          ],
        },
      ],
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      filters: [
        {
          key: "partner",
          title: "Фильтр по партнерам",
          titleKey: "name",
          field_key: "partner",
          selectKey: "name",
        },
        {
          key: "shop",
          title: "Фильтр по торговым точкам",
          titleKey: "name",
          field_key: "shop",
          selectKey: "name",
        },
        {
          key: "user",
          title: "Фильтр по сотрудникам",
          titleKey: "phone",
          field_key: "user",
          selectKey: "name",
        },
        {
          key: "organization",
          title: "Фильтр по организациям",
          titleKey: "name",
          field_key: "organization",
          selectKey: "name",
        },
      ],
      params: {},
      val: [],
      modalCreate: "business",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "item_order",
      itemLink: "reports",
      setLink: "reports",
      columns: [
        {
          key: "order",
          object: "id",
          title: "ID заказа",
        },
        {
          key: "exchange_id",
          title: "ID заказа (партнер)",
        },
        {
          key: "status",
          title: "Статус (партнер)",
        },
        {
          key: "partner",
          object: "name",
          title: "Партнер",
          disableLink: true,
        },
        {
          key: "user",
          object: "phone",
          title: "Продавец",
          disableLink: true,
        },
        {
          key: "month",
          title: "Срок рассрочки",
        },

        {
          key: "shop",
          object: "name",
          disableLink: true,
          title: "Магазин",
        },
        {
          key: "order",
          object: "price_total",
          title: "Цена заказа",
          disableLink: true,
        },
        {
          key: "order",
          object: "created_at",
          title: "Дата заказа",
          dateTimeFormat: true,
          disableLink: true,
        },
        {
          key: "created_at",
          title: "Дата партнера",
          dateTimeFormat: true,
        },
        {
          key: "purchases",
          object: "title",
          title: "Товары",
          disableLink: true,
        },

        {
          disableLink: true,
          key: "discounts",
          object: "promotion_name",
          title: "Акция",
        },
        {
          disableLink: true,
          key: "discounts",
          object: "discount_total",
          title: "Скидка",
        },
        {
          key: "client",
          object: "phone",
          title: "Номер клиента",
        },
        {
          key: "first_customer",
          title: "ККБ",
        },
        // {
        //   detail: true,
        //   // remove: true,
        // },
      ],
    };
  },
};
</script>
<style>
</style>
